import { Component, Input, ViewChild, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { AlunoSae } from '../aluno/aluno-sae';
import { AlunoSaeService } from '../aluno/aluno-sae.service';
import { Estudo } from '../estudo/estudo';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatSort, Sort, MatDialog, MatTableDataSource, MatSnackBar,  PageEvent } from '@angular/material';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { Periodo } from '../util/periodo';

@Component({
    templateUrl: './estudo-list.component.html',
    selector: 'app-estudo-list',
    styleUrls: [ './estudo-list.component.css' ]
})
export class EstudoListComponent implements OnInit, AfterViewInit {

    public filtro: Estudo;
    public ordenar: string;
    public lista: Estudo[];
    public ehAdmin = false;
    public ehDesclassificacao = false;
    public estudosSelecionados: Estudo[] = [];

    @Input() mostrarFiltro = true;

    public columnsToDisplay = [
      'id',
      'alunoNome',
      'matricula',
      'aluNomeCampus',
      'dataInclusao',
      'periodo',
      'situacao',
      'usuarioNome',
      'acao'
    ];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    public dataSource = new MatTableDataSource<Estudo>(this.lista);
    public pageSize = 10;
    public offset: number;

    // MatPaginator Output
    pageEvent: PageEvent;

    // controla o loading da pagina
    // private isLoading: boolean;
    public isLoading: boolean;

    // determina se eh administrador ou aluno. O nome sub eh pra não ficar obvio.
    @Input() sub: boolean;

    // construtor
    constructor(private estudoService: EstudoService, private alunoSaeService: AlunoSaeService,
      private router: Router, private route: ActivatedRoute,
      public mensagem: MatSnackBar, public dialog: MatDialog) {   }

    // ngOnInit é executado ao entrar na tela
    ngOnInit() {
      let filtro: Estudo;
      if (this.route.snapshot.params['filtro']) {
        filtro = JSON.parse(this.route.snapshot.params['filtro']);
      }

      if (!filtro) {
        this.filtro = new Estudo();
      } else {
        this.filtro = filtro;
        this.buscar(filtro);
      }

      // testo pra ver se a rota veio da ocorrencia
      if (this.router.url.indexOf('ocorrencialist') >= 0) {
        this.ehDesclassificacao = true;
      }

      // vejo se eh admin do sistema
      this.controlaPerfis();
    }

    controlaPerfis() {
      const storage = JSON.parse(localStorage.getItem('sae'));
      const resource_owner = storage.resource_owner;
      this.ehAdmin = false;

      if (resource_owner) {
        const lista_perfil = resource_owner.lista_perfil;
        for (const entry of lista_perfil) {
          if (entry && entry.name === 'Administrador') {
            this.ehAdmin = true;
          }
        }
      }
    }

    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
    }


    filtroEmitido(filtro: Estudo) {
      this.filtro = filtro;
      this.buscar(this.filtro);
    }

    // redireciona para novo
    novo() {
      if (this.filtro.alunoRa) {
        this.alunoSaeService.buscarAlunoPorRa(this.filtro.alunoRa).subscribe((result: AlunoSae) => {
            if (result) {
              const matricula = result.registroAcademico; // esse result tah com o resutlaod errado. Investigar isso.
              this.router.navigate(['/estudo', 'new', { matricula: matricula, sub: true}]);
            } else {
                this.mensagem.open('Nenhum aluno encontrado.', 'X', {duration: 5000});
            }
          },
          error =>  this.erro(error)
        );

      } else {
          this.mensagem.open('Digite a matrícula do Aluno', 'X', {duration: 5000});
      }
    }

    // busca com filtro
    public buscar(filtro: Estudo): void {
      this.isLoading = true;
      this.estudoService.filtrar(filtro, this.ordenar).subscribe(
        res => {
          this.lista = res;
          this.dataSource = new MatTableDataSource<Estudo>(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.isLoading = false;
        },
        error =>  this.erro(error)
      );
      this.estudosSelecionados = [];
    }

        // redireciona para editar passando como paramentro o codigo
    editar(codigo: number) {
      this.router.navigate(['/estudo', codigo, { sub: true, filtro: JSON.stringify(this.filtro)}]);
    }

    atribuido(estudo: Estudo) {
      this.isLoading = true;
      this.estudoService.atribuir(estudo).subscribe(result => {
        this.mensagem.open('Estudo atribuído ao usuário.', 'X', {duration: 5000});
        this.isLoading = false;
        this.buscar(this.filtro);
      },
      error =>  this.erro(error));
    }

    desassociarConfirmado(estudo: Estudo) {
      this.isLoading = true;
      this.estudoService.desassociar(estudo).subscribe(result => {
        this.mensagem.open('Estudo desassociado do usuário.', 'X', {duration: 5000});
        this.isLoading = false;
        this.buscar(this.filtro);
      },
      error =>  this.erro(error));
    }

    visualizar(codigo: number) {
      this.router.navigate(['/estudo', codigo]);
    }
    validar(codigo: number) {
      this.router.navigate(['/validacao', codigo, {filtro: JSON.stringify(this.filtro)}]);
    }
    pontuar(codigo: number) {
      this.router.navigate(['/pontuacao', codigo, {filtro: JSON.stringify(this.filtro)}]);
    }

    desassociar(estudo: Estudo){
      const confirmacao: Confirmacao = new Confirmacao('Tem certeza que deseja desassociar o estudo ao usuário atribuído?' , false);
      const dialogRef = this.dialog.open(ConfirmacaoDialog, {
          width: '400px',
          data: confirmacao,
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.desassociarConfirmado(estudo);
          }
        });
    }

   
    public filtrarDinamico(filterValue: string): void {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.dataSource.filter = filterValue;
    }


    public sortData(sort: any) {
      if (!sort.active || sort.direction === '') {
        return;
      } else {
        this.ordenar = sort.active + ' ' + sort.direction ;
        this.buscar(this.filtro);
      }
    }

    /**
     * método chamado quando o botão de desclassificar é emitido. Ele manda um boolean indicando se eh ou não pra atualizar a lista.
     * @param event
     */
    desclassificarEmitido(event: boolean) {
      if (event) {
        this.buscar(this.filtro);
      }
    }


  selecionarTodos() {
    for (const estudo of this.lista ) {
      this.selecionarEstudo(estudo);
    }
  }

  /**
   * Seleciona linhas. Por hora, somente eh usado para desclassificação.
   * @param row
   */
  selecionarEstudo(row: Estudo) {
    if  (this.ehDesclassificacao && this.ehAdmin)  {
      // se for desclassificação nao posso selecionar 'nao concluido', 'pontuado' e 'desclassificado'
      if ( this.ehDesclassificacao && (row.situacao === SituacaoEnum.NaoConcluido ||
          row.situacao === SituacaoEnum.Pontuado ||
          row.situacao === SituacaoEnum.Desclassificado)) {
        return;
      }

      const index = this.estudosSelecionados.indexOf(row, 0);
      if (index > -1 ) {
        // se existir, remove
        this.estudosSelecionados.splice(index, 1);
      } else {
        // se não exitir existir, coloca
        this.estudosSelecionados.push(row);
      }
    }
  }

    // mostra erros na tela
   erro(erro: string) {
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading = false;
   }
}
